/**
 * Modal theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/modal.ts
 */
import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { textStyles } from '../textStyles';
import { ModalBackground } from '../utils/ModalBackground';
import { viewportHeightVariable } from '../utils/useInjectedCssVarOfViewport';
const headerBaseStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'capitalize',
};
const dialogBaseStyle = {
    borderWidth: '1px',
    borderColor: 'brand.gray-scale-border-20',
    background: ModalBackground,
};
const footerBaseStyle = {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
};
const bodyBaseStyle = {
    px: '24px',
    py: '24px',
};
const closeButtonBaseStyle = {
    right: '16px',
    top: '16px',
};
const defaultSize = {
    dialog: {
        rounded: '8px',
    },
    closeButton: closeButtonBaseStyle,
    header: {
        ...textStyles.subtitle3,
        px: '24px',
        pt: '24px',
        pb: '16px',
    },
    body: bodyBaseStyle,
};
export const Modal = {
    parts: parts.keys,
    baseStyle() {
        return {
            header: headerBaseStyle,
            dialog: dialogBaseStyle,
            footer: footerBaseStyle,
        };
    },
    variants: {
        nonIntrusive: {
            overlay: {
                display: 'none',
            },
            dialogContainer: {
                h: '100vh',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
            },
            dialog: {
                ...dialogBaseStyle,
                right: '40px',
            },
            closeButton: closeButtonBaseStyle,
            header: headerBaseStyle,
        },
    },
    sizes: {
        md: defaultSize,
        lg: defaultSize,
        xl: defaultSize,
        '2xl': defaultSize,
        '3xl': defaultSize,
        full(props) {
            /**
             * Fix missing modal footer on iOS.
             * @see https://github.com/chakra-ui/chakra-ui/issues/4903
             */
            const isScrollInside = props.scrollBehavior === 'inside';
            return {
                dialogContainer: {
                    ...(!isScrollInside && fullStyles),
                },
                dialog: {
                    ...(isScrollInside && fullStyles),
                    my: 0,
                    ml: 0,
                    mr: 0,
                    mt: 0,
                    mb: 0,
                },
            };
        },
    },
    defaultProps: {},
};
const fullStyles = {
    minHeight: 'auto',
    maxHeight: 'unset',
    height: `var(${viewportHeightVariable}, -webkit-fill-available)`,
};
